import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import ButtonGroup from "./ButtonGroup";
import Button from "./Button";
import Uploader from "./Uploader";
import ColorPicker from "./ColorPicker";
import TextEditor from "./TextEditor";
import "./ProductOptions.css";

const Configuration = require("./shared/configuration");

class ProductOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stashedBranding: null,
      stashedText: this.props.conf.sign ? this.props.conf.sign.text : null
    };

    this.query = queryString.parse(props.location.search);
    this.renderButtonGroups = this.renderButtonGroups.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
  }

  componentWillReceiveProps(props) {
    if (this.props.conf.branding) {
      this.setState({
        stashedBranding: this.props.conf.branding
      });
    }
  }

  handleTextChange(event) {
    const value = event.target.value.replace(/(\r\n|\n|\r)/gm, "%0A");
    this.setState({ stashedText: value });
    this.updateUrl({ sign: { text: value } });
  }

  handleColorChange(name, color) {
    this.updateUrl({ branding: { [name]: color } });
  }

  updateUrl(obj, conf) {
    this.props.history.push(
      Configuration.configurationToUrl(
        Configuration.configurationWithChanges(conf ? conf : this.props.conf, [
          obj
        ])
      )
    );
  }

  renderButtonGroups(conf, options) {
    return options.map((props, index) => (
      <ButtonGroup
        conf={conf}
        search={this.props.location.search}
        key={index}
        title={this.props.strings[props.title]}
        name={props.name}
        optionTitles={props.optionTitles}
        options={props.options}
        stashedText={this.state.stashedText}
      />
    ));
  }

  renderColorPickers(conf) {
    if (conf.branding === undefined || Configuration.numberOfBrandingColors(conf) === 0) {
      return null;
    }

    var showLegColorPicker = false
    var showSignColorPicker = false
    if (Configuration.numberOfBrandingColors(conf) === 3) {
      showLegColorPicker = true
      showSignColorPicker = true
    } else if (Configuration.numberOfBrandingColors(conf) >= 2) {
      showSignColorPicker = true
    }

    return (
      <div>
        <h3>{this.props.strings.chooseColors}</h3>
        {showSignColorPicker && <div className="PickerGroup">
          <ColorPicker
            title={this.props.strings.textColor}
            color={conf.branding.textColor}
            colors={conf.branding.suggestions}
            name="textColor"
            updateUrl={this.handleColorChange}
            conf={conf}
          />
          <ColorPicker
            title={this.props.strings.backgroundColor}
            color={conf.branding.signColor}
            colors={conf.branding.suggestions}
            name="signColor"
            updateUrl={this.handleColorChange}
            conf={conf}
          />
        </div>}
        {showLegColorPicker && <div className="PickerGroup">
          <ColorPicker
            title={this.props.strings.legColor}
            color={conf.branding.plateColor}
            colors={conf.branding.suggestions}
            name="plateColor"
            updateUrl={this.handleColorChange}
            conf={conf}
          />
        </div>}
      </div>
    );
  }

  renderInputField(conf) {
    const text = conf.sign.text ? conf.sign.text.replace(/%0A/g, "\n") : "";
    return (
      <TextEditor
        questionText={this.state.stashedText || text}
        title={this.props.strings.editQuestion}
        handleChange={this.handleTextChange}
        strings={this.props.strings}
      />
    );
  }

  renderUploader(conf) {
    return (
      <Uploader
        conf={conf}
        visible={conf.branding}
        uploadText={this.props.strings.dropAnImgaFile}
        helper={this.props.strings.addLogoHelper}
        title={this.props.strings.addLogo}
      />
    );
  }

  renderBrandingButtonGroup(conf) {
    return (
      <div>
        <h3>{this.props.strings.addBrandingPack}</h3>
        <div className="ButtonGroup">
          <Button
            active={conf.branding !== undefined}
            title={this.props.strings.yes}
            path={Configuration.configurationToUrl(
              Configuration.configurationWithChange(conf, {
                branding:
                  this.state.stashedBranding || Configuration.defaultBranding()
              })
            )}
          />
          <Button
            active={conf.branding === undefined}
            title={this.props.strings.no}
            path={Configuration.configurationToUrl(
              Configuration.configurationWithChange(conf, {
                branding: null
              })
            )}
          />
        </div>
      </div>
    );
  }

  renderComponents(conf) {
    const components = [
      this.renderButtonGroups(
        conf,
        Configuration.optionsFromConfiguration(conf, this.props.strings)
      ),
      ...(Configuration.isTextInputAvailable(conf)
        ? [this.renderInputField(conf)]
        : []),
      ...(Configuration.isBrandingAvailable(conf)
        ? [this.renderBrandingButtonGroup(conf)]
        : []),
      ...(conf.branding ? [this.renderUploader(conf)] : []),
      ...(conf.branding ? [this.renderColorPickers(conf)] : [])
    ];
    return components;
  }

  render() {
    const { conf } = this.props;
    return <div className="ProductOptions">{this.renderComponents(conf)}</div>;
  }
}
export default withRouter(ProductOptions);



// WEBPACK FOOTER //
// ./src/ProductOptions.js